import React, { Fragment } from 'react';

const CadeComponentHeader = (props) => {
    return (
        <Fragment>
            <h2>{props.cadeDomain}</h2>
            <h5> {props.subTitle}</h5>
        </Fragment>
    );
}

export default CadeComponentHeader;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeComponentHeader.js